<template>
  <path pid="0" d="M20.82 2H5.18A3.18 3.18 0 002 5.18v15.64A3.18 3.18 0 005.18 24h15.64A3.18 3.18 0 0024 20.82V5.18A3.18 3.18 0 0020.82 2zM7 22H5.18A1.18 1.18 0 014 20.82V19h3zm0-5H4v-3h3zm0-5H4V9h3zm0-5H4V5.18A1.18 1.18 0 015.18 4H7zm10 15H9v-8h8zm0-10H9V4h8zm5 8.82A1.18 1.18 0 0120.82 22H19v-3h3zM22 17h-3v-3h3zm0-5h-3V9h3zm0-5h-3V4h1.82A1.18 1.18 0 0122 5.18z"/>
</template>
